import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import PropTypes from 'prop-types';
import findIndex from 'lodash/findIndex';
import map from 'lodash/map';

import useTheme from '@mui/material/styles/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import {
  SortingState,
  IntegratedSorting,
  IntegratedFiltering,
  FilteringState,
  SelectionState,
  PagingState,
  IntegratedSelection,
  IntegratedPaging,
} from '@devexpress/dx-react-grid';

import { SiteIdNameLinkTypeProvider } from '../../table/providers';

import Tooltip from './Tooltip';
import DialogTitleOptions from '../../Dialogs/DialogTitleOptions';
import ROUTES from '../../../constants/routes';
import BaseTable from '../../table/tables/BaseTable';

const getColumns = (pathname) => {
  switch (pathname) {
    case ROUTES.AUTH.ORGANIZATION:
      return [
        { title: 'Site', name: 'site_id', width: 0.4 },
        { title: 'Meter', name: 'name', width: 0.4 },
      ];

    default:
      return [{ title: 'Meter', name: 'name', width: 0.8 }];
  }
};

function SelectMeters(props) {
  const { allMeters, selectedMeters, setSelectedMeters } = props;
  const theme = useTheme();
  const location = useLocation();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));

  const [columns] = useState(getColumns(location.pathname));

  const [open, setOpen] = useState(false);
  const [selection, setSelection] = useState([]);
  const [sorting, setSorting] = useState([{ columnName: 'name' }]);

  useEffect(() => {
    setSelection(
      map(selectedMeters, (meter) => {
        return findIndex(allMeters, { meter_id: meter.meter_id });
      })
    );
    /* eslint-disable-next-line */
  }, [open]);

  const handleSelect = () => {
    setSelectedMeters(
      map(selection, (idx) => {
        return allMeters[idx];
      })
    );
    setSelection([]);
    handleClose();
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip
        title={
          <List disablePadding>
            {map(selectedMeters, (meter) => {
              if (meter.meter_id) {
                return (
                  <ListItem sx={{ p: 1, pt: 0, pb: 0 }} key={meter.meter_id}>
                    <ListItemText
                      slotProps={{
                        primary: {
                          color: theme.palette.primary.main,
                        },
                      }}>
                      {meter.name}
                    </ListItemText>
                  </ListItem>
                );
              } else return null;
            })}
          </List>
        }>
        <Button
          color='primary'
          onClick={() => setOpen(true)}
          sx={{ width: '4rem' }}>
          Meters
        </Button>
      </Tooltip>
      <Dialog open={open} onClose={handleClose} fullScreen={isMobile}>
        <DialogTitle>
          Select Meters
          <DialogTitleOptions handleClose={handleClose} />
        </DialogTitle>
        <DialogContent sx={{ maxWidth: 500 }}>
          <BaseTable
            rows={allMeters}
            columns={columns}
            selection
            maxWidth={500}>
            <SiteIdNameLinkTypeProvider for={['site_id']} />
            <SelectionState
              selection={selection}
              onSelectionChange={setSelection}
            />
            <FilteringState />
            <SortingState sorting={sorting} onSortingChange={setSorting} />
            <PagingState defaultCurrentPage={0} pageSize={10} />
            <IntegratedFiltering />
            <IntegratedSorting />
            <IntegratedSelection />
            <IntegratedPaging />
          </BaseTable>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant='contained' onClick={handleSelect}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

SelectMeters.propTypes = {
  allMeters: PropTypes.array,
  selectedMeters: PropTypes.array,
  setSelectedMeters: PropTypes.func,
};

export default SelectMeters;
